import { render, staticRenderFns } from "./logoutPage.vue?vue&type=template&id=eb898d8c&scoped=true&"
import script from "./logoutPage.vue?vue&type=script&lang=js&"
export * from "./logoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb898d8c",
  null
  
)

export default component.exports